import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import * as Yup from "yup";
import { useFormik } from "formik";
import "../Validations/errors.css";
import dayjs from 'dayjs';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PaymentFilters from "./PaymentFilters";
import Select from "react-select";


const baseUrl = process.env.REACT_APP_BASE_URL;


const Payments = ({ tierLabel, tiersApi }) => {
    const validationSchema = Yup.object({
        paymentModeId: Yup.number()
            .required("Le mode de règlement est obligatoire"),

        amount: Yup.number()
            .required("Le montant est obligatoire")
            .min(0.01, "Montant invalide"),

        datePayment: Yup.date()
            .required("La date est obligatoire"),
        ...(tierLabel === "Client"
            ? {
                clientId: Yup.number().required("Client obligatoire")
            }
            : {
                supplierId: Yup.number().required("Fournisseur obligatoire")
            })
    });
    const [payments, setPayments] = useState([]);
    const initialFilters = {
        paymentModeId: "",
        tierId: "",
        minAmount: "",
        maxAmount: ""
    };
    const [filters, setFilters] = useState(initialFilters);
    const [paymentModes, setPaymentModes] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [history, setHistory] = useState([]);
    const [releve, setReleve] = useState([]);
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const initialValues = {
        id: 0,
        reference: "",
        clientId: 0,
        supplierId: 0,
        paymentModeId: 0,
        tiersName: "",
        amount: 0,
        datePayment: "",
        dateEcheance: ""
    };

    const [selectedPayment, setSelectedPayment] = useState(null);
    const remainingPayment = selectedPayment?.amount - selectedPayment?.totalAssigned;
    const [tiers, setTiers] = useState([]);
    const isClient = tierLabel === "Client";
    const [documentTypeFilter, setDocumentTypeFilter] = useState("");
    const [historyTypeFilter, setHistoryTypeFilter] = useState("");
    const documentTypes = isClient
        ? [
            { value: "Facture", label: "Factures" },
            { value: "BL", label: "Bons de Livraison" },
            { value: "BCV", label: "Bons de Commande" }
        ]
        : [
            { value: "FactureAchat", label: "Factures" },
            { value: "BRA", label: "Bons de Réception" },
            { value: "BCA", label: "Bons de Commande" }
        ];
    const filteredDocuments = documentTypeFilter
        ? documents.filter(d => d.type === documentTypeFilter)
        : documents;

    const filteredHistory = historyTypeFilter
        ? history.filter(h => h.documentType === historyTypeFilter)
        : history;
    const columnsRelve = [
        "Date",
        "Opération",
        "Débit",
        "Crédit",
    ];
    const tierOptions = useMemo(
        () =>
            tiers.map(tier => ({
                value: tier.id,
                label: tier.name
            })),
        [tiers]
    );
    useEffect(() => {
        fetchTiers();
        fetchPaymentModes();
        fetchPayments();
    }, []);
    function convertToInputDateFormat(dateStr) {
        // Attend une date au format dd/MM/yyyy
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    const fetchTiers = () => {
        axiosInstance.get(`${baseUrl}/api/${tiersApi}`)
            .then(res => setTiers(res.data))
            .catch(() => console.log("Impossible de charger les données"));
    };
    const fetchDocuments = (payment) => {
        const tierId = isClient ? payment.clientId : payment.supplierId;
        const type = isClient ? "vente" : "achat";

        axiosInstance
            .get(`${baseUrl}/api/Payments/PayableDocuments`, {
                params: { tierId, type }
            })
            .then(res => {
                const data = res.data.map(doc => ({
                    ...doc,
                    checked: false,
                    amount: ""
                }));

                setDocuments(data);
            })
            .catch(() => console.log("Erreur chargement documents"));
    };
    // const fetchDocuments = (payment) => {
    //     const tierId = isClient ? payment.clientId : payment.supplierId;
    //     axiosInstance
    //         .get(`${baseUrl}/api/Payments/PayableDocuments?clientId=${tierId}`)
    //         // .then(res => setDocuments(res.data));
    //         .then(res => {
    //             const data = res.data.map(doc => ({
    //                 ...doc,
    //                 amount: doc.remaining // ✅ valeur par défaut
    //             }));

    //             setDocuments(data);
    //         });
    // };
    // const fetchPayments = () => {
    //     const type = tierLabel === "Client" ? "Client" : "Fournisseur";

    //     axiosInstance.get(`${baseUrl}/api/Payments?type=${type}`)
    //         .then(res => {
    //             const formattedData = res.data.map(item => ({
    //                 ...item,
    //                 datePayment: item.datePayment
    //                     ? dayjs(item.datePayment).format('DD/MM/YYYY')
    //                     : "",
    //                 dateEcheance: item.dateEcheance
    //                     ? dayjs(item.dateEcheance).format('DD/MM/YYYY')
    //                     : ""
    //             }));

    //             setPayments(formattedData);
    //         })
    //         .catch(() => console.log("Impossible de charger."));
    // };

    const fetchPayments = () => {
        const type = tierLabel === "Client" ? "Client" : "Fournisseur";

        const query = {
            type,
            paymentModeId: filters.paymentModeId || null,
            tierId: filters.tierId || null,
            minAmount: filters.minAmount || null,
            maxAmount: filters.maxAmount || null
        };
        console.log(query);
        axiosInstance.get(`${baseUrl}/api/Payments`, { params: query })
            .then(res => {
                const formattedData = res.data.map(item => ({
                    ...item,
                    datePayment: item.datePayment
                        ? dayjs(item.datePayment).format('DD/MM/YYYY')
                        : "",
                    dateEcheance: item.dateEcheance
                        ? dayjs(item.dateEcheance).format('DD/MM/YYYY')
                        : ""
                }));

                setPayments(formattedData);
            })
            .catch(() => console.log("Impossible de charger."));
    };

    const fetchPaymentModes = () => {
        axiosInstance.get(`${baseUrl}/api/PaymentModes`)
            .then(res => setPaymentModes(res.data))
            .catch(() => console.log("Erreur chargement modes."));
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,

        onSubmit: async (values, { setErrors }) => {
            try {
                const url = values.id
                    ? `${baseUrl}/api/Payments/Update`
                    : `${baseUrl}/api/Payments/Create`;
                console.log("data submitted : ", values)
                await axiosInstance.post(url, values);

                fetchPayments();
                resetForm();
                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Opération réussie",
                    showConfirmButton: false,
                    timer: 2000
                });
            } catch (err) {
                if (err.response?.data?.errors) {
                    setErrors(err.response.data.errors);
                } else {
                    Swal.fire("Erreur", "Erreur serveur", "error");
                }
            }
        }
    });

    const resetForm = () => {
        formik.resetForm();
        setSelectedPayment(null);
    };

    const handleEdit = (item) => {
        console.log("Voici le paiement sélectionné :", item);


        const formattedPayment = {
            ...item,
            clientId: item.clientId || 0,
            supplierId: item.supplierId || 0,
            datePayment: convertToInputDateFormat(item.datePayment),
            dateEcheance: convertToInputDateFormat(item.dateEcheance)
        };

        setSelectedPayment(formattedPayment);
        formik.setValues(formattedPayment);

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };
    const handleAssign = async () => {
        console.log("Mes docs", documents)
        const lines = documents
            .filter(d => d.checked && Number(d.amount) > 0)
            .map(d => ({
                documentId: d.id,
                documentNumber: d.numero,
                documentType: d.type,
                amount: Number(d.amount)
            }));

        const payload = {
            paymentId: selectedPayment.id,
            lines: lines
        };

        console.log("Payload envoyé :", payload);

        if (lines.length === 0) {
            Swal.fire("Attention", "Cochez au moins un document.", "warning");
            return;
        }
        if (totalSelection > resteReglement + 0.001) {
            Swal.fire("Attention", `Le total sélectionné (${totalSelection.toFixed(2)} MAD) dépasse le reste du règlement (${resteReglement.toFixed(2)} MAD).`, "warning");
            return;
        }

        try {
            await axiosInstance.post(
                `${baseUrl}/api/PaymentLines/Assign`,
                payload
            );
            fetchPayments();

            Swal.fire("Succès", "Affectation réussie", "success");

            window.$("#modalAssign").modal("hide");

        } catch (err) {
            const errors = err.response?.data?.errors;

            if (errors) {
                const message = Object.values(errors).join("\n");

                Swal.fire(
                    "Erreur",
                    message,
                    "error"
                );
            } else {
                Swal.fire(
                    "Erreur",
                    err.response?.data?.message || "Erreur serveur",
                    "error"
                );
            }
        }
    };
    const openAssignModal = (item) => {
        console.log("Voici le paiement sélectionné :", item);


        const formattedPayment = {
            ...item,
            clientId: item.clientId || 0,
            supplierId: item.supplierId || 0,
            datePayment: convertToInputDateFormat(item.datePayment),
            dateEcheance: convertToInputDateFormat(item.dateEcheance)
        };

        setSelectedPayment(formattedPayment);
        fetchDocuments(formattedPayment);
        formik.setValues(formattedPayment);

        setTimeout(() => {
            window.$("#modalAssign").modal("show");
        }, 100);
    };
    const handleAmountChange = (id, value) => {
        setDocuments(prev =>
            prev.map(doc =>
                doc.id === id ? { ...doc, amount: value, checked: Number(value) > 0 || doc.checked } : doc
            )
        );
    };

    // ===== Règlement par lot : cases à cocher =====
    const resteReglement = Number(selectedPayment?.remaining ?? 0);
    const totalSelection = documents
        .filter(d => d.checked)
        .reduce((t, d) => t + Number(d.amount || 0), 0);

    // Cocher un document : montant proposé = min(reste du document, reste du règlement non encore réparti)
    const handleCheck = (id) => {
        setDocuments(prev => {
            const dejaReparti = prev.filter(d => d.checked && d.id !== id)
                .reduce((t, d) => t + Number(d.amount || 0), 0);
            return prev.map(doc => {
                if (doc.id !== id) return doc;
                if (doc.checked) return { ...doc, checked: false, amount: "" };
                const dispo = Math.max(0, resteReglement - dejaReparti);
                const montant = Math.min(Number(doc.remaining || 0), dispo);
                return { ...doc, checked: true, amount: montant > 0 ? montant.toFixed(2) : "" };
            });
        });
    };

    // Tout cocher : répartit le reste du règlement du plus ancien au plus récent (documents visibles)
    const visiblesIds = filteredDocuments.map(d => d.id);
    const toutCoche = filteredDocuments.length > 0 && filteredDocuments.every(d => d.checked);
    const handleCheckAll = () => {
        setDocuments(prev => {
            if (toutCoche) {
                return prev.map(d => visiblesIds.includes(d.id) ? { ...d, checked: false, amount: "" } : d);
            }
            let dispo = resteReglement - prev.filter(d => d.checked && !visiblesIds.includes(d.id))
                .reduce((t, d) => t + Number(d.amount || 0), 0);
            const ordre = [...prev].filter(d => visiblesIds.includes(d.id))
                .sort((a, b) => new Date(a.dateDocument || 0) - new Date(b.dateDocument || 0))
                .map(d => d.id);
            const montants = {};
            ordre.forEach(id => {
                const doc = prev.find(d => d.id === id);
                const m = Math.max(0, Math.min(Number(doc.remaining || 0), dispo));
                montants[id] = m;
                dispo -= m;
            });
            return prev.map(d => visiblesIds.includes(d.id)
                ? { ...d, checked: true, amount: montants[d.id] > 0 ? montants[d.id].toFixed(2) : "" }
                : d);
        });
    };
    const openHistory = (item) => {
        console.log("Paiement sélectionné :", item);

        setSelectedPayment(item);

        axiosInstance
            .get(`${baseUrl}/api/PaymentLines/History/${item.id}`)
            .then(res => {
                setHistory(res.data);
            })
            .catch(() => {
                console.log("Erreur chargement historique");
            });

        setTimeout(() => {
            window.$("#modalHistory").modal("show");
        }, 100);

    };
    const fetchReleve = async () => {

        const res = await axiosInstance.get(
            `${baseUrl}/api/Payments/Releves-Client`,
            {
                params: {
                    clientId: selectedPayment.clientId,
                    dateDebut,
                    dateFin
                }
            }
        );

        setReleve(res.data);
    };
    const exportReleve = async (payment) => {

        const dateDebut = "2026-01-01";
        const dateFin = "2026-12-31";

        const res = await axiosInstance.get(
            `${baseUrl}/api/Payments/Releves-Client`,
            {
                params: {
                    clientId: payment.clientId,
                    dateDebut,
                    dateFin
                }
            }
        );

        exportRelevePdf(
            payment.tiersName,
            res.data,
            dateDebut,
            dateFin
        );
    };
    const exportRelevePdf = (
        clientName,
        releve,
        dateDebut,
        dateFin
    ) => {

        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.getWidth();

        // =====================
        // Logo
        // =====================

        const logoPath =
            `${process.env.PUBLIC_URL}/dist/img/logo_.png`;

        doc.addImage(
            logoPath,
            "PNG",
            10,
            5,
            40,
            30
        );

        // =====================
        // Titre
        // =====================

        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");

        doc.text(
            "RELEVE CLIENT",
            pageWidth / 2,
            20,
            { align: "center" }
        );

        // =====================
        // Infos
        // =====================

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        doc.text(
            `Client : ${clientName}`,
            14,
            45
        );

        doc.text(
            `Du ${dayjs(dateDebut).format("DD/MM/YYYY")} au ${dayjs(dateFin).format("DD/MM/YYYY")}`,
            14,
            52
        );

        // =====================
        // Tableau
        // =====================

        autoTable(doc, {
            startY: 65,

            head: [[
                "Date",
                "Opération",
                "Débit",
                "Crédit",
                // "Solde"
            ]],

            body: releve.map(x => [
                dayjs(x.dateOperation).format("DD/MM/YYYY"),
                `${x.type} ${x.numero}`,
                x.debit > 0 ? x.debit.toFixed(2) : "",
                x.credit > 0 ? x.credit.toFixed(2) : "",
                // x.solde.toFixed(2)
            ]),

            styles: {
                fontSize: 9
            },

            headStyles: {
                fillColor: [41, 128, 185]
            }
        });

        // =====================
        // Totaux
        // =====================

        const totalDebit =
            releve.reduce(
                (sum, x) => sum + x.debit,
                0
            );

        const totalCredit =
            releve.reduce(
                (sum, x) => sum + x.credit,
                0
            );

        const soldeFinal =
            totalDebit - totalCredit;

        const finalY =
            doc.lastAutoTable.finalY + 10;

        autoTable(doc, {
            startY: finalY,

            head: [[
                "Total Débit",
                "Total Crédit",
                "Solde"
            ]],

            body: [[
                totalDebit.toFixed(2),
                totalCredit.toFixed(2),
                soldeFinal.toFixed(2)
            ]],

            styles: {
                fontSize: 10
            },

            tableWidth: 90,

            margin: {
                left: pageWidth - 104
            }
        });

        doc.save(
            `Releve_${clientName}.pdf`
        );
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Payments/Delete`, {
                    id: id,
                    idString: ""
                }).then(() => fetchPayments());
            }
        });
    };

    const hasDocuments = documents && documents.length > 0;
    return (

        <div className="container-fluid mt-4">
            <PaymentFilters
                filters={filters}
                setFilters={setFilters}
                onSearch={fetchPayments}
                paymentModes={paymentModes}
                tiers={tiers}
                tierLabel={tierLabel}
            />
            <h3 className="text-center my-3">Gestion des Règlements</h3>

            <button
                className="btn btn-primary btn-ajouter mb-3"
                data-toggle="modal"
                data-target="#modalForm"
                onClick={resetForm}
            >
                <i className="fas fa-plus"></i> Ajouter
            </button>

            <DataTableComponent
                data={payments}
                title="Liste des Règlements"
                columns={["reference", "tiersName", "amount", "datePayment", "dateEcheance"]}
                columnsMapping={{
                    reference: "Référence",
                    amount: "Montant",
                    datePayment: "Date Paiement",
                    dateEcheance: "Date Echeance",
                    tiersName: tierLabel
                }}
                keyField="id"
                handleEdit={handleEdit}
                openAssignModal={openAssignModal}
                openHistory={openHistory}
                exportReleve={exportReleve}
                handleDelete={handleDelete}
            />

            <div className="modal fade" id="modalAssign">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>
                                Affectation du règlement : {selectedPayment?.reference}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">

                            {/* Tableau des documents */}
                            {!hasDocuments ? (
                                <div className="text-center text-muted py-4">
                                    <i className="fas fa-info-circle mb-2" style={{ fontSize: "24px" }}></i>
                                    <p>Aucun document à payer</p>
                                </div>
                            ) : (
                                <>
                                    {/* <div className="alert alert-info mt-2">
                                        💳 Règlement : <b>{selectedPayment?.amount} MAD</b>
                                        <span className="mx-3"></span>
                                        Reste à affecter : <b>{documents[0]?.remaining.toFixed(2)} MAD</b>
                                    </div> */}

                                    <div className="alert alert-light mt-2 d-flex justify-content-start align-items-center gap-4 p-3 row">
                                        <span className="badge bg-primary px-3 py-2 fs-6 me-3 col-md-5" style={{ marginLeft: "20px" }}
                                        >
                                            💳 Règlement : <b>{selectedPayment?.amount} MAD</b>
                                        </span>
                                        <div className="col-md-1"></div>
                                        <span className="badge bg-warning text-dark px-3 py-2 fs-6 col-md-5">
                                            ⏳ Reste : <b>{(resteReglement - totalSelection).toFixed(2)} MAD</b>
                                        </span>

                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label>Type document</label>
                                            <select
                                                className="form-control"
                                                value={documentTypeFilter}
                                                onChange={(e) => setDocumentTypeFilter(e.target.value)}
                                            >
                                                <option value="">Tous</option>

                                                {documentTypes.map(type => (
                                                    <option
                                                        key={type.value}
                                                        value={type.value}
                                                    >
                                                        {type.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 40 }} className="text-center">
                                                    <input type="checkbox" title="Tout cocher"
                                                        checked={toutCoche} onChange={handleCheckAll} />
                                                </th>
                                                <th>Document</th>
                                                <th>Montant</th>
                                                <th>Reste</th>
                                                <th>Montant à affecter</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredDocuments.map(doc => (
                                                <tr key={doc.id} className={doc.checked ? "table-success" : ""}>
                                                    <td className="text-center">
                                                        <input type="checkbox" checked={!!doc.checked}
                                                            onChange={() => handleCheck(doc.id)} />
                                                    </td>
                                                    <td>{doc.numero}</td>
                                                    <td>{doc.total}</td>
                                                    <td>{doc.remaining}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={doc.amount || ""}
                                                            disabled={!doc.checked}
                                                            max={doc.remaining}
                                                            onChange={(e) =>
                                                                handleAmountChange(doc.id, e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className={`text-right font-weight-bold ${totalSelection > resteReglement + 0.001 ? "text-danger" : ""}`}>
                                        {documents.filter(d => d.checked).length} document(s) sélectionné(s) — Total : {totalSelection.toFixed(2)} MAD
                                        {" / "}Reste à affecter : {(resteReglement - totalSelection).toFixed(2)} MAD
                                    </div>
                                </>

                            )}

                        </div>
                        {hasDocuments && (
                            <div className="modal-footer">
                                <button className="btn btn-secondary" data-dismiss="modal">
                                    Annuler
                                </button>

                                <button className="btn btn-success" onClick={handleAssign}
                                    disabled={totalSelection <= 0 || totalSelection > resteReglement + 0.001}>
                                    Valider l’affectation
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalHistory">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>
                                Historique du règlement : {selectedPayment?.reference}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">

                            {!history || history.length === 0 ? (
                                <div className="text-center text-muted py-4">
                                    <i className="fas fa-clock mb-2" style={{ fontSize: "24px" }}></i>
                                    <p>Aucune affectation trouvée</p>
                                </div>
                            ) : (
                                <>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label>Type document</label>
                                            <select
                                                className="form-control"
                                                value={historyTypeFilter}
                                                onChange={(e) => setHistoryTypeFilter(e.target.value)}
                                            >
                                                <option value="">Tous</option>

                                                {documentTypes.map(type => (
                                                    <option
                                                        key={type.value}
                                                        value={type.value}
                                                    >
                                                        {type.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Document</th>
                                                <th>Montant affecté</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredHistory.map(h => (
                                                <tr key={h.id}>
                                                    <td>{h.documentNumber}</td>
                                                    <td>{h.amount}</td>
                                                    <td>{dayjs(h.createdAt).format("DD/MM/YYYY HH:mm")}</td>                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>

                            )}

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal">
                                Fermer
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>
                                {selectedPayment ? "Modifier" : "Ajouter"} un Règlement
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">

                            {/* Mode de règlement */}
                            <div className="form-group">
                                <label>Mode de règlement</label>
                                <select
                                    name="paymentModeId"
                                    className={`form-control mb-2 ${formik.touched.paymentModeId && formik.errors.paymentModeId ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.paymentModeId}
                                    onChange={formik.handleChange}
                                >
                                    <option value="">-- Choisir --</option>
                                    {paymentModes.map(m => (
                                        <option key={m.id} value={m.id}>
                                            {m.nameLat}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Tiers */}
                            <div className="form-group">
                                <label>{tierLabel}</label>

                                <Select
                                    classNamePrefix="react-select"
                                    placeholder={`-- Choisir ${tierLabel} --`}
                                    options={tierOptions}
                                    isClearable
                                    value={
                                        tierOptions.find(
                                            x =>
                                                x.value === Number(
                                                    isClient
                                                        ? formik.values.clientId
                                                        : formik.values.supplierId
                                                )
                                        ) || null
                                    }
                                    onChange={selected =>
                                        formik.setFieldValue(
                                            isClient ? "clientId" : "supplierId",
                                            selected ? selected.value : ""
                                        )
                                    }
                                    onBlur={() =>
                                        formik.setFieldTouched(
                                            isClient ? "clientId" : "supplierId",
                                            true
                                        )
                                    }
                                />

                                {formik.touched[isClient ? "clientId" : "supplierId"] &&
                                    formik.errors[isClient ? "clientId" : "supplierId"] && (
                                        <div className="text-danger mt-1">
                                            {formik.errors[
                                                isClient ? "clientId" : "supplierId"
                                            ]}
                                        </div>
                                    )}
                            </div>

                            {/* Montant */}
                            <div className="form-group">
                                <label>Montant</label>
                                <input
                                    type="number"
                                    name="amount"
                                    className={`form-control mb-2 ${formik.touched.amount && formik.errors.amount ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.amount}
                                    onChange={formik.handleChange}
                                />
                            </div>

                            {/* Date paiement */}
                            <div className="form-group">
                                <label>Date de paiement</label>
                                <input
                                    type="date"
                                    name="datePayment"
                                    className="form-control mb-2"
                                    value={formik.values.datePayment}
                                    onChange={formik.handleChange}
                                />
                            </div>

                            {/* Date échéance */}
                            <div className="form-group">
                                <label>Date échéance</label>
                                <input
                                    type="date"
                                    name="dateEcheance"
                                    className="form-control mb-2"
                                    value={formik.values.dateEcheance}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={resetForm}
                            >
                                Annuler
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={formik.handleSubmit}
                                disabled={formik.isSubmitting}
                            >
                                Sauvegarder
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Payments;